import React from "react";

import useUniqueId from "components/useUniqueId";
import { useTheme } from "theme";

import IconBox from "../IconBox";

export type CopyIconProps = {
  color?: string;
  /**
   * True if the icon is purely decorative (doesn't add information about content on the page)
   */
  decorative?: boolean;
  /**
   * Label for the icon. Only set if there is no existing element that labels it
   */
  label?: string;
  /**
   * Id of the element that labels this icon
   */
  labelledById?: string;
};

const CopyIcon: React.FC<CopyIconProps> = props => {
  const { color, decorative, label } = props;
  const labelledBy = useUniqueId();
  const title = label && <title id={labelledBy}>{label}</title>;
  const theme = useTheme();
  const stroke = color ?? theme.palette.primary.fsBlue;
  return (
    <IconBox>
      <svg
        aria-hidden={decorative}
        aria-labelledby={labelledBy}
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        version="1.1"
      >
        {title}
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <g
            transform="translate(-1186.000000, -2802.000000)"
            stroke={stroke}
            strokeWidth="2"
          >
            <g transform="translate(0.000000, 2670.000000)">
              <g transform="translate(1187.000000, 133.000000)">
                <g>
                  <rect x="5.6" y="5.6" width="10.4" height="10.4" rx="1.6" />
                  <path d="M2.4,10.4 L1.6,10.4 C0.7163444,10.4 0,9.6836556 0,8.8 L0,1.6 C0,0.7163444 0.7163444,0 1.6,0 L8.8,0 C9.6836556,0 10.4,0.7163444 10.4,1.6 L10.4,2.4" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </IconBox>
  );
};

export default CopyIcon;
